/**
 * TypeSms
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {TypeSmsCollection} from '@/model/collection/TypeSmsCollection'

/* TODO: review generated class */
export class TypeSms extends Resource {
  idTypePk: number = 0

  ativo: boolean | null = null

  nome: string | null = null

  get $id() {
    return this.idTypePk
  }
  set $id(val) {
    this.idTypePk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of TypeSms
   */
  async getTypeSms(id: number) {
    return await Request.get(`/admin/type-sms/${id}`)
      .name('getTypeSms')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of TypeSms
   */
  async removeTypeSms() {
    return await Request.delete(`/admin/type-sms/${this.$id}`)
      .name('removeTypeSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TypeSms
   */
  static async listTypeSms(params: any) {
    return await Request.get(`/admin/type-sms`, {params})
      .name('listTypeSms')
      .as(TypeSmsCollection)
      .getData()
  }

  /**
   * Persists a new instance of TypeSms. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTypeSms() {
    return await Request.post(`/admin/type-sms`, this)
      .name('persistTypeSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TypeSms to use it in a CSV file
   */
  static async listCsvTypeSms(params: any) {
    return await Request.get(`/admin/type-sms/csv`, {params})
      .name('listCsvTypeSms')
      .as(TypeSmsCollection)
      .getData()
  }
}
